import { render } from "./user_list_popover.vue?vue&type=template&id=3dc0c2d4"
import script from "./user_list_popover.js?vue&type=script&lang=js"
export * from "./user_list_popover.js?vue&type=script&lang=js"

import "./user_list_popover.vue?vue&type=style&index=0&id=3dc0c2d4&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__